<script setup lang="ts">
import { dismiss, useToasts } from "../composables/useToast";

const messages = useToasts();
</script>

<template>
  <Teleport to="body">
    <div class="ro-toast-host" aria-live="polite">
      <button
        v-for="toast in messages"
        :key="toast.id"
        class="ro-toast"
        :class="`is-${toast.tone}`"
        type="button"
        @click="dismiss(toast.id)"
      >{{ toast.message }}</button>
    </div>
  </Teleport>
</template>
